export default {
    SET_CHAT_FLOWS(state, chatFlows) {
        state.chatFlows = chatFlows
    },
    SET_CHAT_FLOW_INFOS(state, chatFlowInfos) {
        state.chatFlowInfos = chatFlowInfos
    },
}
